"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  rpc: {
    poolState: {
      description: '',
      params: [{
        name: 'pool_id',
        type: 'u32'
      }, {
        name: 'currency_id',
        type: 'CurrencyId'
      }],
      type: 'SyntheticPoolState'
    }
  },
  types: {
    SyntheticPoolState: {
      collateral_ratio: 'FixedI128',
      is_safe: 'boolean'
    }
  }
};
exports.default = _default;